export default __webpack_public_path__ + "static/media/paybolt-token-icon.97e14dbd.svg";